(function () {
  var el = document.getElementById('calibrate-per-serve');
  if (!el) return;
  var SACHETS = parseInt(el.dataset.sachets || '25', 10);
  var basePrice = parseInt(el.dataset.base || '0', 10);

  function fmt(cents) {
    return '$' + (cents / 100 / SACHETS).toFixed(2);
  }
  function upd(cents) {
    var priceEl = document.getElementById('cps-price');
    if (priceEl) priceEl.textContent = fmt(cents);
  }
  function check() {
    var s = document.querySelector('input[name="selling_plan"]:checked');
    upd(s ? Math.round(basePrice * 0.9) : basePrice);
  }

  document.addEventListener('variant:change', function (ev) {
    if (ev.detail && ev.detail.variant) {
      basePrice = ev.detail.variant.price;
      check();
    }
  });

  var observer = new MutationObserver(check);
  var productInfo = document.querySelector('.product-info');
  if (productInfo) {
    observer.observe(productInfo, {
      subtree: true, attributes: true, childList: true,
      attributeFilter: ['checked', 'value']
    });
  }
  check();
})();
